// Autogenerated file
export const periodTypesEnum = {
    Day: "Day",
    Week: "Week",
    Month: "Month",
    Year: "Year",
};
export const periodTypes = [
    { label: "День", value: "Day" },
    { label: "Неделя", value: "Week" },
    { label: "Месяц", value: "Month" },
    { label: "Год", value: "Year" },
];
